// Copyright (C) 2013 Minted Inc.
// All Rights Reserved
// Dependancies: string.js

/*
  UMD header generated via modularize.js at 2015-04-02T22:17:54.657Z
*/
var module; UMD(module, {
  'minted:m': ['M'],
  'minted:vendor/backbone-1.0.0.min': 'Backbone',
  'minted:vendor/jquery-1.9.1.min': '$',
  'minted:vendor/underscore-1.8.2.min': '_',
  'minted:constants': []
})(this, function (m_module, Backbone, $, _) {

var M = m_module.M;

M.Model = M.Model || {};

M.Model.ProductImage = Backbone.Model.extend({
  defaults: {
    dieCutCode: null,
    colorChoice: "A",
    colorCode: "A",
    photoCode: null,
    showBacker: false,
    ext: 'jpg'
  },

  /**
   * @param sku, ex: 'abc-123-xyz'
   * @param photoCode, ex: 'CP'
   * @param colorCode, ex: 'A'
   * @param viewCode, ex: '007'
   * @param dieCutCode, ex: 'B'
   * @param showBacker, ex: false
   * @optional param greeting, ex: Holiday
   * @optional param greetingIndex, ex: 1
   * @optional param colorChoiceId, ex: 12345
   * @optional param layoutName, ex: 'l1'
   * @optional param basePDPUrl,
   *   ex: '/product/new-year-photo-cards/MIN-5B5-HNY/vintage'
   */
  initialize: function() {
    this.validate();
    this.bind('change', function() {
      this.validate();
    });
  },

  validate: function() {
    M.required(this.get('sku'));
    M.required(this.get('photoCode'));
    M.required(this.get('viewCode'));
    M.required(this.get('colorCode'));
    M.required(this.get('dieCutCode'));
    M.required(this.get('showBacker'));
  },

  getPdpUrl: function() {
    var basePdpUrl = this.get('basePdpUrl');
    M.required(basePdpUrl);

    var queryParamString = this._getPdpQueryParams();
    if (queryParamString) {
      return basePdpUrl + '?' + queryParamString;
    } else {
      return basePdpUrl;
    }
  },

  _getPdpQueryParams: function() {
    var result = {};
    if (this.get('colorChoiceId')) {
      result['ccId'] = this.get('colorChoiceId');
    }

    if (this.get('dieCutCode')) {
      result['dcC'] = this.get('dieCutCode');
    }

    if (this.get('greetingIndex')) {
      result['agI'] = this.get('greetingIndex');
    }

    // Make sure that the origin param is set, this allows us to track
    // which path the user took to get to the PDP.
    result['org'] = 'photo';

    return $.param(result);
  },

  // Keep in sync with minted.web.product
  getImgUrl: function() {
    var viewCode = this.get('viewCode');
    var dieCutCode = this.get('dieCutCode');
    var photoCode = this.get('photoCode');
    var colorCode = this.get('colorCode');
    var showBacker = this.get('showBacker');
    var greeting = this.get('greeting');
    var layoutName = this.get('layoutName');
    var ext = this.get('ext');
    var sku = this.get('sku');
    var parts = sku.split('-');
    var brand = parts[0];
    var collection = parts[1];
    var kind = parts[2];

    var categoryViews = [
      M.PRODUCT_IMAGE.VIEW_CODE.BACKER_CURL_UP,
      M.PRODUCT_IMAGE.VIEW_CODE.FRONT,
      M.PRODUCT_IMAGE.VIEW_CODE.FRONT_WITH_SHAPE,
      M.PRODUCT_IMAGE.VIEW_CODE.SEARCH
    ];

    var pdpViews = [
      M.PRODUCT_IMAGE.VIEW_CODE.FRONT_COMPOSITE,
      M.PRODUCT_IMAGE.VIEW_CODE.BACKER,
      M.PRODUCT_IMAGE.VIEW_CODE.TABLET
    ];

    // All non front view codes only have jpegs
    if (viewCode !== M.PRODUCT_IMAGE.VIEW_CODE.FRONT_COMPOSITE) {
      ext = 'jpg';
    }

    if (showBacker && _.contains(categoryViews, viewCode)) {
      viewCode = M.PRODUCT_IMAGE.VIEW_CODE.BACKER_CURL_UP;
    } else if (dieCutCode && _.contains(categoryViews, viewCode)) {
      // Use the 011 view + die cut code (Category images)
      viewCode = M.PRODUCT_IMAGE.VIEW_CODE.FRONT_WITH_SHAPE + dieCutCode;
    } else if (dieCutCode && _.contains(pdpViews, viewCode)) {
      // Append the diecut code suffix (PDP images)
      if (viewCode === M.PRODUCT_IMAGE.VIEW_CODE.TABLET && !M.isDigitalInvitationProduct){
        //Diecut does not apply for Free Wedding Website (005) in pdp
        dieCutCode = '';
      }
      viewCode = viewCode + dieCutCode;
    }

    if (_(M.SKU.PARTY_PICK_AND_PACK_KINDS).contains(kind)) {
      viewCode = M.PRODUCT_IMAGE.VIEW_CODE.FRONT_COMPOSITE;
    }

    // Append greeting to url for PDP and the /my-favorites page
    var greetingViews = [
      M.PRODUCT_IMAGE.VIEW_CODE.FRONT_COMPOSITE,
      M.PRODUCT_IMAGE.VIEW_CODE.FRONT,
      M.PRODUCT_IMAGE.VIEW_CODE.FRONT_WITH_SHAPE
    ];

    if (greeting && _.contains(greetingViews, viewCode.substring(0,3))) {
      greeting = M.GetGreetingUrlParamFromName(greeting);
    } else {
      greeting = '';
    }

    if (layoutName) {
      layoutName = layoutName.toUpperCase();
      viewCode = M.PRODUCT_IMAGE.LAYOUT_MAPPINGS[viewCode + '_' + layoutName];
    }

    var context = {
      basePath: 'files/mintedProductsImages',
      brand: brand,
      collection: collection,
      kind: kind,
      sku: sku,
      photoCode: photoCode,
      viewCode: viewCode,
      colorCode: colorCode,
      dieCutCode: dieCutCode,
      greeting: greeting,
      ext: ext
    };

    var s3key = '';
    s3key += context.basePath + '/';
    s3key += context.brand + '/';
    s3key += context.kind + '/';
    s3key += context.collection + '/';
    s3key += context.sku + '-';
    s3key += context.viewCode + context.greeting + '_' + context.colorCode;
    if (context.photoCode) {
      s3key += "_" + context.photoCode;
    } else {
      s3key += '';
    }
    s3key += '.' + context.ext;
    return 'https://' + M.MINTEDCDN_HTTP_HOST + '/' + s3key + '?_=' + M.GENERATION_NUMBER;
  }
});

return {
  ProductImage: M.Model.ProductImage
};

});
